const translationRU = {
    generalData: 'Общие данные',
    name: 'Полное имя',
    nameParam: 'Имя',
    date: 'Дата',
    phoneNumber: 'Телефон',
    patientGeneralData: 'Общие данные пациента',
    detailData: 'Детальные данные',
    feetMeasurement: 'Измерение стоп',
    overview: 'Обзор',
    firstNameRequired: 'Требуется имя',
    firstName: 'Имя',
    lastName: 'Фамилия',
    identityId: 'ID',
    emailLabel: 'E-mail',
    phoneNumber1: 'Номер телефона 1',
    phoneNumber2: 'Номер телефона 2',
    gender: 'Пол',
    selectGender: 'Пожалуйста, выберите пол',
    male: 'Мужской',
    female: 'Женский',
    dateofBirth: 'Дата рождения',
    birthDateRequired: 'Требуется дата рождения',
    height: 'Рост',
    weight: 'Вес',
    shoeSize: 'Размер обуви',
    euShoeSize: 'Размер обуви (EU)',
    rightHanded: 'Правша',
    leftHanded: 'Левша',
    controlExamSchedule: 'График контрольного обследования',
    ekovelReport: 'Отчет Эковел',
    generalExamination: 'Общее обследование',
    optimalWeight: 'Оптимальный вес',
    feetParametes: 'Параметры стоп',
    role: 'Роль',
    displayName: 'Отображаемое имя',
    userName: 'Имя пользователя',
    organization: 'Организация',
    active: 'Активный',
    deleteConfirmation: 'Подтверждение удаления',
    areYouSureToDelete: 'Вы уверены, что хотите удалить пользователя',
    delete: 'Удалить',
    cancel: 'Отмена',
    deactivate: 'Деактивировать',
    activate: 'Активировать',
    activateUser: 'Активировать пользователя',
    deactivateConfirmation: 'Подтверждение деактивации',
    areYouSureDeactivate: 'Вы уверены, что хотите деактивировать пользователя',
    areYouSureActivate: 'Вы уверены, что хотите активировать пользователя',
    updateSerialNumber: 'Обновить серийный номер',
    areYouSureToDeleteUser: 'Вы уверены, что хотите удалить пользователя',
    actions: 'Действия',
    parameter: 'Параметр',
    value: 'Значение',
    ekovelStepCorrectsize: 'Этап Эковел: правильный размер',
    initialHeight: 'Начальный рост',
    optimalHeight: 'Оптимальный рост',
    firstCheck: 'Первая проверка',
    secondCheck: 'Вторая проверка',
    thirdCheck: 'Третья проверка',
    therapy: 'Терапия',
    leftFoot: 'Левая стопа',
    rightFoot: 'Правая стопа',
    serialNumber: 'Серийный номер',
    footLength: 'Длина стопы (мм)',
    footWidth: 'Ширина стопы (мм)',
    left: 'Левый',
    right: 'Правый',
    back: 'Назад',
    finish: 'Завершить',
    next: 'Далее',
    selectLeg: 'Выбрать ногу',
    legLengthDifference: 'Разница в длине ног',
    adjustmentInterval: 'Интервал настройки',
    adjustmentPeriod: 'Период настройки ИИ',
    week: 'Неделя',
    weeks: 'Недели',
    serialNumberDate: 'Дата серийного номера',
    checkExaminationSchedule: 'Проверить график обследования',
    escSize: 'Размер ЭСК',
    saveAndOpenReport: 'Сохранить и открыть отчет',
    create: 'Создать',
    noRowsToShowPatients: 'Нет данных',
    DepthOfFootArch: 'Глубина арки стопы',
    DegreeOfTendon: 'Положение сухожилия',
    LegLengthDifference: 'Разница в длине ног',
    FootprintSplit: 'Разделение следа стопы',
    FootParamDescription: 'Описание параметров стопы',
    report: 'Отчет',
    examinationDate: 'Дата обследования',
    leftFootMeasurement: 'Измерения левой стопы',
    rightFootMeasurement: 'Измерения правой стопы',
    footParametersLeft: 'Параметры левой стопы',
    footParametersRight: 'Параметры правой стопы',
    optimalMlaDepth: 'Оптимальная глубина МЛА',
    optimalMlaHeight: 'Оптимальная высота МЛА',
    mlaDescendingLevel: 'Уровень спуска МЛА',
    mlaDescending: 'Спуск МЛА',
    tendonPosition: 'Положение сухожилия',
    legAlignement: 'Выравнивание ног',
    and: 'И',
    selectedLeg: 'Выбранная нога',
    allAdmins: 'ВСЕ АДМИНИСТРАТОРЫ',
    allUsers: 'ВСЕ ПОЛЬЗОВАТЕЛИ',
    allPatients: 'ВСЕ ПАЦИЕНТЫ',
    therapyDuration: 'Длительность терапии',
    medialArchDisplacement: 'Смещение медиальной арки',
    verticalDisplacement: 'Вертикальное смещение',
    horizontalDisplacement: 'Горизонтальное смещение',
    displacementPoourcentage: 'Процент смещения',
    displacementLevel: 'Уровень смещения',
    medialArchDepth: 'Глубина медиальной арки X [мм]',
    medialArchHeight: 'Высота медиальной арки Y [мм]',
    tendonBendingDegree: 'Степень изгиба сухожилия',
    medialArchOptimalDepth: 'Оптимальная глубина медиальной арки Xo [мм]',
    medialArchOptimalHeight: 'Оптимальная высота медиальной арки Yo [мм]',
    backToPatientsList: 'Вернуться к форме',
    allStepsAreDone: 'Все шаги завершены',
    user: 'Пользователь',
    yes: 'Да',
    no: 'Нет',
    selectAlignment: 'Выбрать выравнивание',
    createAdmin: 'Создать администратора/пользователя',
    createUser: 'Создать пользователя',
    createPatient: 'Создать пациента',
    editPatient: 'Редактировать пациента',
    serialNumberSucces: 'Серийный номер успешно обновлен',
    noRowsToShow: 'Нет результатов для отображения',
    admittedBy: 'Принято',
    logout: 'Выйти',
    search: 'Поиск',
    suborganization: 'Подорганизация',
    town: 'Город',
    userSuccess: "Успешно создано",
    emailAlreadyExist: "Ошибка: Email уже существует",
    loginErroMEssage: 'Неправильное имя пользователя или пароль.',
    accept: 'Принять',

    privacyPolicy: "Политика конфиденциальности",
    lastUpdated: "Дата последнего обновления: 03.04.2025",
    privacyPolicyIntro: "Добро пожаловать в приложение компании Эковел. Мы стремимся защищать вашу конфиденциальность и безопасность ваших персональных данных. Настоящая Политика конфиденциальности объясняет, какие данные мы собираем, как мы их используем и как их храним.",
    dataCollectionTitle: "1. СОБРАНИЕ ДАННЫХ",
    personalData: "Персональные данные пациентов: имя, фамилия, дата рождения, контактная информация.",
    therapyData: "Данные о терапии: медицинские заключения, рекомендованные процедуры, данные о ортопедических стельках.",
    technicalData: "Технические данные: информация об устройстве, IP-адрес, данные о использовании приложения.",
    dataUsageTitle: "2. ИСПОЛЬЗОВАНИЕ ДАННЫХ",
    dataUsage1: "Ведение учета пациентов и их терапий.",
    dataUsage2: "Создание и индивидуальная настройка ортопедических стелек.",
    dataUsage3: "Повышение качества обслуживания и функциональности приложения.",
    dataUsage4: "Выполнение юридических и регуляторных обязательств.",
    dataStorageTitle: "3. ХРАНЕНИЕ И ЗАЩИТА ДАННЫХ",
    dataProtection: "Ваши данные хранятся на защищенных серверах с ограниченным доступом и защищены соответствующими мерами безопасности. Доступ к данным имеют только уполномоченные лица, и данные не передаются третьим лицам без вашего согласия, за исключением случаев, предусмотренных законом.",
    userRightsTitle: "4. ПРАВА ПОЛЬЗОВАТЕЛЯ",
    userRights1: "Доступ к своим данным.",
    userRights2: "Запрос на исправление неточных данных.",
    userRights3: "Запрос на удаление данных, когда они больше не нужны.",
    userRights4: "Отзыв согласия на обработку данных.",
    contactRights: "Для осуществления своих прав, свяжитесь с нами по адресу ekovelcentar@gmail.com",
    privacyPolicyAcceptanceTitle: "5. ПРИНИМАНИЕ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ",
    privacyPolicyAcceptance: "Используя это приложение, пользователи подтверждают, что прочитали, поняли и согласны с Политикой конфиденциальности. При первом запуске приложения будет показана эта Политика конфиденциальности, а дальнейшее использование приложения будет доступно только после того, как пользователь нажмет кнопку «Согласен».",
    contactTitle: "6. КОНТАКТ",
    contactIntro: "Если у вас есть вопросы по поводу этой Политики конфиденциальности, вы можете связаться с нами по адресу:",
    companyName: "ЭКОВЕЛ ЦЕНТАР DOO",
    companyAddress: "Угриновацкий путь 104, 11080, Белград (Земун), Сербия",
    companyEmail: "Email: ekovelcentar@gmail.com",
    companyPhone: "Телефон: 0113774750",
    policyUpdateNotice: "Мы оставляем за собой право периодически обновлять эту Политику конфиденциальности. О любых изменениях вы будете своевременно уведомлены через приложение."
  
};

export { translationRU };
